<template>
  <div class="toolbar">
    <div class="btn btn--round btn--home">
      <svg viewBox="0 0 48 48" @click="$emit('home')">
        <path
          d="M19.7004 29.3984H29.3004M23.7586 14.6237L15.4386 20.2502C15.1009 20.4785 14.9004 20.8482 14.9004 21.2422V31.7725C14.9004 32.7809 15.76 33.5984 16.8204 33.5984H32.1804C33.2408 33.5984 34.1004 32.7809 34.1004 31.7725V21.2422C34.1004 20.8482 33.8998 20.4785 33.5622 20.2502L25.2422 14.6237C24.7981 14.3234 24.2027 14.3234 23.7586 14.6237Z"
        />
      </svg>
    </div>
    <div class="toolbar__paginator">
      <div
        class="btn btn--arrow"
        :class="{ 'btn--disabled': !prev }"
        @click="$emit('prev')"
      >
        <svg viewBox="0 0 48 48">
          <path
            d="M28.1705 31.5455C28.6098 31.1062 28.6098 30.3938 28.1705 29.9545L22.216 24L28.1705 18.0455C28.6098 17.6062 28.6098 16.8938 28.1705 16.4545C27.7312 16.0152 27.0188 16.0152 26.5795 16.4545L19.8295 23.2045C19.3902 23.6438 19.3902 24.3562 19.8295 24.7955L26.5795 31.5455C27.0188 31.9848 27.7312 31.9848 28.1705 31.5455Z"
          />
        </svg>
      </div>
      <div
        class="btn btn--arrow"
        :class="{ 'btn--disabled': !next }"
        @click="$emit('next')"
      >
        <svg viewBox="0 0 48 48">
          <path
            d="M19.8295 31.5455C19.3902 31.1062 19.3902 30.3938 19.8295 29.9545L25.784 24L19.8295 18.0455C19.3902 17.6062 19.3902 16.8938 19.8295 16.4545C20.2688 16.0152 20.9812 16.0152 21.4205 16.4545L28.1705 23.2045C28.6098 23.6438 28.6098 24.3562 28.1705 24.7955L21.4205 31.5455C20.9812 31.9848 20.2688 31.9848 19.8295 31.5455Z"
          />
        </svg>
      </div>
    </div>
    <div
      class="btn btn--round btn--video"
      :class="{ 'btn--disabled': !video }"
      @click="$emit('video')"
    >
      <svg viewBox="0 0 48 48">
        <path
          d="M32.6447 22.8649C34.0502 23.6772 34.0554 24.699 32.6447 25.6173L21.7449 33.2406C20.3754 33.9986 19.4453 33.551 19.3476 31.911L19.3014 15.9556C19.2705 14.4449 20.4705 14.0181 21.6139 14.7424L32.6447 22.8649Z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prev: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Boolean,
      default: true,
    },
    video: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
}
.toolbar__paginator {
  display: flex;
  justify-content: center;
}
.btn {
  box-shadow: 0px 7px 10px rgba(85, 85, 112, 0.41);
  background: #fff;
  border: 1px solid #ffd100;
  cursor: pointer;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem;
  color: #292983;

  @include media-breakpoint-down(md) {
    height: 2rem;
    padding: 0 1rem;
  }

  &:hover {
    background: #292983;
    border-color: #292983;
    color: #fff;
  }

  &--round {
    width: 3rem;
    padding: 0;

    @include media-breakpoint-down(md) {
      width: 2rem;
    }
  }

  &--home {
    svg {
      width: 26px;
      height: 26px;
      fill: currentColor;

      @include media-breakpoint-down(md) {
        width: 16px;
        height: 16px;
      }
    }
  }
  &--arrow {
    margin: 0 1rem;

    @include media-breakpoint-down(md) {
      margin: 0 0.5rem;
    }

    svg {
      width: 28px;
      height: 14px;
      fill: currentColor;

      @include media-breakpoint-down(md) {
        width: 20px;
        height: 10px;
      }
    }
  }
  &--video {
    svg {
      width: 24px;
      height: 24px;
      fill: none;
      stroke-linejoin: round;
      stroke-width: 2;
      stroke: currentColor;

      @include media-breakpoint-down(md) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &--disabled {
    opacity: 0.3;
    cursor: default;
    pointer-events: none;
  }
}
</style>
